module.exports = __webpack_public_path__ + "img/擦汗.85e1a3b2.png";